// Size the workspace below the app header; chat and details scroll independently.
export default {
  data: () => ({ agentViewportStyle: {} }),
  mounted () { this.$nextTick(this.resizeAgentViewport); window.addEventListener('resize', this.resizeAgentViewport); if (window.visualViewport) window.visualViewport.addEventListener('resize', this.resizeAgentViewport) },
  updated () { this.resizeAgentViewport() },
  beforeDestroy () { window.removeEventListener('resize', this.resizeAgentViewport); if (window.visualViewport) window.visualViewport.removeEventListener('resize', this.resizeAgentViewport) },
  methods: {
    resizeAgentViewport () {
      const page = this.$refs.agentPage
      if (!page) return
      const height = window.visualViewport ? window.visualViewport.height : window.innerHeight
      const available = Math.max(240, height - page.getBoundingClientRect().top - 12) + 'px'
      if (this.agentViewportStyle.height !== available) this.agentViewportStyle = { height: available }
    }
  }
}
